var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H8C6.9 0 6 0.9 6 2V18C6 19.1 6.9 20 8 20H20C21.1 20 22 19.1 22 18V6L16 0ZM8 18V2H15V7H20V18H8Z",
    fill: "#89A6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6C2 4.9 2.9 4 4 4H8V6H4V22H16V18H18V22C18 23.1 17.1 24 16 24H4C2.9 24 2 23.1 2 22V6Z",
    fill: "#89A6FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H10V12H8V10Z",
    fill: "#89A6FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12H12V14H10V12Z",
    fill: "#89A6FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10H14V12H12V10Z",
    fill: "#89A6FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12H16V14H14V12Z",
    fill: "#89A6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.94f2cd57b2bb4fc784d5fabd27d79133.svg";
export { ForwardRef as ReactComponent };